import React from 'react';

const MobilePreview = ({
    profileContent,
    activeProfile,
    activeReportType,
    activeSection,
    activeLang
}) => {
    const profileData = profileContent[activeProfile] || {};
    const reportTypeData = profileData[activeReportType] || {};

    const langLabel = {
        en: 'English',
        hi: 'Hindi',
        ar: 'Arabic',
        cz: 'Czech'
    }[activeLang] || activeLang;

    // Render About preview
    const renderAboutPreview = () => {
        const about = reportTypeData.about || {};
        const header = about.header?.[activeLang] || '';
        const text = about.text?.[activeLang] || '';

        return (
            <div className="pfc-preview-about">
                {header ? (
                    <h4 className="pfc-preview-header">{header}</h4>
                ) : (
                    <div className="pfc-preview-skeleton-header"></div>
                )}
                {text ? (
                    <p className="pfc-preview-text">{text}</p>
                ) : (
                    <>
                        <div className="pfc-preview-skeleton-text"></div>
                        <div className="pfc-preview-skeleton-text short"></div>
                    </>
                )}
                {about.mediaUrl && (
                    <div className="pfc-preview-media">
                        <div className="pfc-media-placeholder">
                            <span>Video/Image</span>
                        </div>
                    </div>
                )}
            </div>
        );
    };

    // Render Tips preview
    const renderTipsPreview = () => {
        const tips = reportTypeData.tips || [];

        if (tips.length === 0) {
            return (
                <div className="pfc-preview-empty">
                    <div className="pfc-preview-skeleton-card"></div>
                    <div className="pfc-preview-skeleton-card"></div>
                </div>
            );
        }

        return (
            <div className="pfc-preview-tips">
                {tips.map((section, sIdx) => (
                    <div key={sIdx} className="pfc-preview-tip-card">
                        {section.header?.[activeLang] && (
                            <div className="pfc-tip-card-header">
                                {section.header[activeLang]}
                            </div>
                        )}
                        <div className="pfc-tip-card-body">
                            {section.subHeader?.[activeLang] && (
                                <p className="pfc-tip-subheader">
                                    {section.subHeader[activeLang]}
                                </p>
                            )}
                            <ul className="pfc-tip-list">
                                {section.tipsArray?.map((tip, tIdx) => (
                                    <li key={tIdx}>
                                        {tip.text?.[activeLang] || '...'}
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>
                ))}
            </div>
        );
    };

    // Render Others preview
    const renderOthersPreview = () => {
        return (
            <div className="pfc-preview-others">
                {reportTypeData.href && (
                    <div className="pfc-preview-link-card">
                        <span>🔗 External Link</span>
                        <small>
                            {reportTypeData.href.length > 30
                                ? `${reportTypeData.href.substring(0, 30)}...`
                                : reportTypeData.href}
                        </small>
                    </div>
                )}
                <div className="pfc-preview-info-card">
                    <strong>Recommendations</strong>
                    <p>{reportTypeData.recommendation || 'None'}</p>
                </div>
            </div>
        );
    };

    return (
        <div className="pfc-mobile-preview-container">
            <div className="pfc-phone-wrapper">
                <div className="pfc-phone-case">
                    {/* Notch Removed */}

                    <div className="pfc-phone-screen">
                        {/* App Header */}
                        <div className="pfc-app-header">
                            {/* Status Bar Removed */}
                            <div className="pfc-app-nav">
                                <span>←</span>
                                <span>{activeProfile}</span>
                                <span>⋮</span>
                            </div>
                            <div className="pfc-app-tabs">
                                <span className={activeSection === 'about' ? 'active' : ''}>Overview</span>
                                <span className={activeSection === 'tips' ? 'active' : ''}>Tips</span>
                            </div>
                        </div>

                        {/* Content Scroll Area */}
                        <div className="pfc-app-content">
                            {activeSection === 'about' && renderAboutPreview()}
                            {activeSection === 'tips' && renderTipsPreview()}
                            {activeSection === 'others' && renderOthersPreview()}
                        </div>

                        {/* Bottom Tab Bar Mockup - Icons Removed */}
                        <div className="pfc-app-tabbar">
                            {/* Icons removed as per request */}
                        </div>

                    </div>

                    {/* Home Indicator */}
                    <div className="pfc-home-indicator"></div>
                </div>
            </div>
            <div className="pfc-preview-caption">Live {langLabel} Preview</div>
        </div>
    );
};

export default MobilePreview;
